export default (user, large) => {
  const { image } = user
  if (!user.image) {
    return null
  }
  return large ? image.large : image.thumbnail
}
